import React, { useState, useContext, useCallback, useMemo } from "react";
import { Context } from "../../../../index";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react-lite";
import PopupModule from "../../../../components/forms/popupModule";
import UniversalForm from "../../../../components/forms/UniversalForm";
import ButtonComponent from "../../../../components/buttons/ButtonComponent";
import SquareButton from "../../../../components/buttons/SquareButton";
import SVG from "../../../../components/svg/Svg";
import Modal from "../../../../components/forms/wrap/Modal";
import { useModal } from "../../../../components/hooks/useModal";

import "./styles.css";

export default observer(function Modules() {
  const { store, uiStore, inplantsStore } = useContext(Context);
  const navigate = useNavigate();

  const modal = useModal(false); // ✅ Управление модалкой
  const [mode, setMode] = useState<"create">("create"); // пока только create
  const [isHide, setHide] = useState(true); // исправляем тип: boolean

  // --- Открытие формы создания ---
  const openCreateForm = useCallback(() => {
    setMode("create");
    inplantsStore.setActiveModule(null);
    modal.open();
  }, [modal]); // eslint-disable-line react-hooks/exhaustive-deps

  // --- Закрытие формы ---
  const handleCloseModal = useCallback(() => {
    inplantsStore.setActiveModule(null);
    modal.close();
  }, [modal]); // Возвращаем modal в зависимости

  const lineOptions = useMemo(
    () =>
      inplantsStore.lines
        .filter((line) => !line.is_smb)
        .map((line) => ({
          id: line.id.toString(),
          name: line.name,
        })),
    [inplantsStore.lines],
  );

  const typeOptions = useMemo(
    () => [
      { id: "mmb", name: "ММБ" },
      { id: "mdbn", name: "МДБН" },
    ],
    [],
  );

  // --- Создание модуля ---
  const createNewModule = useCallback(
    async (data: any) => {
      await inplantsStore.createModule(data);
    },
    [inplantsStore],
  );

  // --- Переключение списка ---
  const toggleList = useCallback(() => {
    setHide((prev) => !prev);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // --- Выбор модуля (для PopupModule) ---
  const selectModule = useCallback(
    (module_id: number | null) => {
      if (inplantsStore.activeModule?.id) {
        inplantsStore.setActiveModule(null);
        return;
      }
      const curModule = inplantsStore.modules.find((el) => el.id === module_id);
      if (curModule) {
        inplantsStore.setActiveModule(curModule);
      }
    },
    [inplantsStore.activeModule?.id, inplantsStore.modules], // eslint-disable-line react-hooks/exhaustive-deps
  );

  // --- Иконка статуса ---
  const statusIcon = useCallback((status: string) => {
    const fill = status === "online" ? "#48BA67" : "#FF5454";
    return (
      <svg
        width="11"
        height="10"
        viewBox="0 0 11 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.61108 0C2.84608 0 0.611084 2.235 0.611084 5C0.611084 7.765 2.84608 10 5.61108 10C8.37608 10 10.6111 7.765 10.6111 5C10.6111 2.235 8.37608 0 5.61108 0Z"
          fill={fill}
        />
      </svg>
    );
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <div className="module_container">
        <div className="lines_head">
          <div className="lines_head_title">МОДУЛИ ОБЪЕКТА {SVG["line"]}</div>

          <div className="lines_headbtns">
            {inplantsStore.lines.length ? (
              <ButtonComponent
                title="Добавить модуль"
                svg="create"
                onClick={openCreateForm}
                size="180px"
              />
            ) : null}

            <SquareButton
              icon={isHide ? "close_colored" : "creat_colored"}
              background="white"
              border="2px solid #1894c3"
              size="36px"
              onClick={toggleList}
            />
          </div>
        </div>

        {isHide && (
          <div className="module_content">
            {inplantsStore.modules.map((el) => {
              const isFilteredOut =
                uiStore.selectedLineId !== null &&
                el.line_id !== uiStore.selectedLineId;
              return (
                <div
                  className={`module_item ${
                    uiStore.selectedModuleId === el.id
                      ? "module_item--selected"
                      : ""
                  } ${isFilteredOut ? "module_item--filtered" : ""}`}
                  key={el.id}
                  onClick={() =>
                    !isFilteredOut && uiStore.setSelectedModuleId(el.id)
                  }
                  style={{ cursor: isFilteredOut ? "not-allowed" : "pointer" }}
                >
                  <div
                    className="module_title"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (!isFilteredOut) selectModule(el.id);
                    }}
                    style={{
                      cursor: isFilteredOut ? "not-allowed" : "pointer",
                    }}
                  >
                    {el.charge_id}
                  </div>
                  <div className="module_data">Лимит: {el.limit || 0} A</div>
                  <div className="module_data">
                    Фаза А - {el.value_A || 0} A
                  </div>
                  <div className="module_data">
                    Фаза B - {el.value_B || 0} A
                  </div>
                  <div className="module_data">
                    Фаза C - {el.value_C || 0} A
                  </div>
                  <div
                    className={
                      el.status === "online"
                        ? "module_online"
                        : "module_offline"
                    }
                  >
                    {el.status === "online" ? "на связи" : "нет связи"}{" "}
                    {statusIcon(el.status || "offline")}
                  </div>

                  {/* Кнопка графиков */}
                  {/*<SquareButton
                    icon="chart"
                    border="2px solid #1894c3"
                    size="36px"
                    onClick={() =>
                      navigate(`/Mymodule-charts/${el.id}/${el.charge_id}`)
                    }
                  />*/}

                  {store.user?.role === "root" ? (
                    <SquareButton
                      icon="chart"
                      border="2px solid #1894c3"
                      size="36px"
                      onClick={() => {
                        const chartPath =
                          el.device_type === "mmb"
                            ? `/module-charts/mmb/${el.id}/${el.charge_id}/${el.line_name}`
                            : el.device_type === "smb"
                              ? `/module-charts/smb/${el.id}/${el.charge_id}/${el.line_name}`
                              : `/Mymodule-charts/${el.id}/${el.charge_id}/${el.line_name}`;
                        navigate(chartPath);
                      }}
                    />
                  ) : null}
                </div>
              );
            })}
          </div>
        )}
      </div>

      {/* ✅ Единая модалка для создания */}
      <Modal isOpen={modal.isOpen} onClose={handleCloseModal}>
        <UniversalForm
          mode={mode}
          handleCloseModal={handleCloseModal}
          fields={{
            charge_id: { label: "Идентификатор Модуля", required: true },
            serial: { label: "SN Модуля", required: true },
            limit: { label: "Лимит" },
            line_id: {
              label: "Выберете линию",
              type: "select",
              options: lineOptions,
              required: true,
            },
            primary_current: { label: "Первичный ток ТТ" },
            description: { label: "Описание" },

            device_type: {
              label: "Тип",
              type: "select",
              options: typeOptions,
              required: true,
            },
            url: {label: "url"},
            port:{label: "port"}
          }}
          createEntity={createNewModule}
          title="Добавить модуль"
        />
      </Modal>

      {/* ✅ Оставляем PopupModule, если это отдельная модалка (например, клик по модулю) */}
      <Modal
        isOpen={!!inplantsStore.activeModule?.id}
        onClose={() => selectModule(null)}
      >
        {inplantsStore.activeModule?.id && (
          /* `I.11` (`АРХ-Н9`): карточка модуля со страницы объекта получает те же
             обработчики секрета изделия и пароля точки, что и со страницы «Все
             модули» (`AllModules.tsx:91–96`). Прежде их здесь не передавали, и
             «Показать пароль», «Сменить», «Внести» отвечали «чтение пароля
             недоступно», не уходя на сервер. */
          <PopupModule
            module={inplantsStore.activeModule}
            lines={inplantsStore.lines}
            stations={inplantsStore.stations}
            modules={inplantsStore.modules}
            handleCloseModal={() => selectModule(null)}
            updateModule={(module, stations, childModules, modifiedKeys) => inplantsStore.updateModule(module, stations, childModules, modifiedKeys)}
            updateChildModules={(parentModule, childModules, modifiedKeys) => inplantsStore.updateChildModules(parentModule, childModules, modifiedKeys)}
            updateSmbModules={(module, stations, modifiedKeys) => inplantsStore.updateSmbModules(module, stations, modifiedKeys)}
            deleteModule={(id) => inplantsStore.deleteModule(id)}
            restartModule={(identifier) => inplantsStore.restartModule(identifier)}
            fetchDeviceSecretStatus={(id) => store.fetchDeviceSecretStatus(id)}
            issueDeviceSecret={(id) => store.issueDeviceSecret(id)}
            revokeDeviceSecret={(id) => store.revokeDeviceSecret(id)}
            fetchApPassword={(id) => store.fetchApPassword(id)}
            rotateApPassword={(id) => store.rotateApPassword(id)}
            importApPassword={(id, apPassword) => store.importApPassword(id, apPassword)}
            onModuleSaved={(patch) => {
              // `АУД-Н331`: после сохранения берём свежую строку из `modules`,
              // а не копию прежнего `activeModule` — иначе сохранённый лимит
              // откатывался бы на экране.
              const activeId = inplantsStore.activeModule?.id;
              const fresh =
                activeId != null
                  ? inplantsStore.modules.find(
                      (item) => Number(item.id) === Number(activeId),
                    )
                  : null;

              // `АУД-Н342`: при сбое перечитывания `fresh` устарел — сохранённое
              // поверх него.
              if (fresh) {
                inplantsStore.setActiveModule({ ...fresh, ...patch });
              } else if (inplantsStore.activeModule) {
                inplantsStore.setActiveModule({
                  ...inplantsStore.activeModule,
                  ...patch,
                });
              }
            }}
            refreshData={() => {
              if (inplantsStore.plant?.id) {
                return inplantsStore.loadPlantData(inplantsStore.plant.id);
              }
              return undefined;
            }}
          />
        )}
      </Modal>
    </>
  );
});
